import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

const OptOut = () => {
  const [formData, setFormData] = useState({
    phone_number: '',
    email: '',
    reason: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const { data, error } = await supabase
        .from('opt_out_requests')
        .insert([{
          ...formData,
          created_at: new Date().toISOString(),
          status: 'pending'
        }]);

      if (error) throw error;

      setSubmitMessage('Your opt-out request has been processed successfully. You will no longer receive SMS messages from us.');
      setFormData({
        phone_number: '',
        email: '',
        reason: ''
      });
    } catch (error) {
      setSubmitMessage('There was an error processing your opt-out request. Please try again or contact support.');
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{paddingTop: '100px'}}>
      <section className="section">
        <div className="container">
          <h1 className="section-title">SMS Opt-Out Request</h1>
          
          <div style={{maxWidth: '600px', margin: '0 auto'}}>
            <div style={{background: '#f0f9ff', padding: '2rem', borderRadius: '10px', marginBottom: '2rem', border: '2px solid #2563eb'}}>
              <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Unsubscribe from SMS Messages</h2>
              <p>
                We respect your communication preferences. If you no longer wish to receive SMS messages from 
                MEES HOLDINGS INC, please complete the form below or reply STOP to any of our text messages.
              </p>
            </div>

            <div className="form-container">
              <h2 style={{color: '#2563eb', marginBottom: '1.5rem'}}>Opt-Out Request Form</h2>
              
              {submitMessage && (
                <div style={{
                  background: submitMessage.includes('error') ? '#fef2f2' : '#f0fdf4',
                  color: submitMessage.includes('error') ? '#ef4444' : '#16a34a',
                  padding: '1rem',
                  borderRadius: '5px',
                  marginBottom: '1.5rem',
                  border: `2px solid ${submitMessage.includes('error') ? '#ef4444' : '#16a34a'}`
                }}>
                  {submitMessage}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="phone_number">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone_number"
                    name="phone_number"
                    value={formData.phone_number}
                    onChange={handleChange}
                    placeholder="Enter the phone number to opt out"
                    required
                  />
                  <small style={{color: '#6b7280', fontSize: '0.9rem'}}>
                    Include country code if applicable (e.g., +1 for US numbers)
                  </small>
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address (Optional)</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your email address for confirmation"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="reason">Reason for Opting Out (Optional)</label>
                  <select
                    id="reason"
                    name="reason"
                    value={formData.reason}
                    onChange={handleChange}
                  >
                    <option value="">Select a reason</option>
                    <option value="too_frequent">Messages too frequent</option>
                    <option value="not_relevant">Content not relevant</option>
                    <option value="never_subscribed">Never subscribed</option>
                    <option value="privacy_concerns">Privacy concerns</option>
                    <option value="changed_number">Changed phone number</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Processing...' : 'Submit Opt-Out Request'}
                </button>
              </form>
            </div>

            <div style={{background: '#fef2f2', padding: '2rem', borderRadius: '10px', marginTop: '2rem', border: '2px solid #ef4444'}}>
              <h3 style={{color: '#ef4444', marginBottom: '1rem'}}>Alternative Opt-Out Methods</h3>
              <ul style={{lineHeight: '1.8', paddingLeft: '1.5rem'}}>
                <li><strong>Text STOP:</strong> Reply STOP to any SMS message you receive from us</li>
                <li><strong>Text UNSUBSCRIBE:</strong> Reply UNSUBSCRIBE to any SMS message</li>
                <li><strong>Email:</strong> Send an email to optout@meesmarketing.com</li>
                <li><strong>Contact Form:</strong> Use our contact form at meesmarketing.com/contact</li>
              </ul>
            </div>

            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px', marginTop: '2rem'}}>
              <h3 style={{color: '#2563eb', marginBottom: '1rem'}}>Important Information</h3>
              <ul style={{lineHeight: '1.8', paddingLeft: '1.5rem', fontSize: '0.95rem'}}>
                <li>Opt-out requests are processed within 24 hours</li>
                <li>You may still receive transactional messages related to your account</li>
                <li>Opting out applies only to marketing and promotional messages</li>
                <li>You can opt back in at any time by contacting us</li>
                <li>We maintain opt-out records as required by law</li>
              </ul>
            </div>

            <div style={{textAlign: 'center', marginTop: '2rem'}}>
              <p style={{color: '#6b7280', fontSize: '0.9rem'}}>
                If you have any questions about opting out or our SMS practices, please contact us at 
                <strong> support@meesmarketing.com</strong> or visit our <a href="/contact" style={{color: '#2563eb'}}>contact page</a>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OptOut;